export const getFloatingHideStyles = (
  hideData: { referenceHidden?: boolean } | undefined
): { visibility: "hidden" | "visible" } => ({
  visibility: hideData?.referenceHidden ? "hidden" : "visible",
});
